module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.game.id < 200) ? _c('lanTrainIntroduction', {
    attrs: {
      "game": _vm.game
    },
    on: {
      "close2": _vm.closeCogn
    }
  }) : _c('cognTrainIntroduction', {
    attrs: {
      "game": _vm.game
    },
    on: {
      "close2": _vm.closeCogn
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dae89d98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/train/digTrainContentmodal.vue
// module id = 1028
// module chunks = 2